import React from 'react'
import style from './KeyContact.module.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import Employee from "../Employee/Employee.jsx";

export default function KeyContact( {teamsData} ) {
    return (
        <>
            <div className={style.transparentLine}></div>
            <div className={style.keyContact}>
                <div className='container'>
                    <h2 className={style.title}>Ключевые контакты</h2>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        className="mySwiperSpecializations"
                        breakpoints={{
                            600: {
                                slidesPerView: "auto",
                                spaceBetween: 80,
                            },
                        }}
                    >
                        {teamsData.map((team, index) => {
                            return (
                                <SwiperSlide key={index}>
                                    <Employee
                                        firstName={team.attributes.firstName}
                                        lastName={team.attributes.lastName}
                                        img={team.attributes.userAvatar.data.attributes}
                                    />
                                </SwiperSlide>
                            )
                        })}
                    </Swiper>
                </div>
            </div>
        </>

    )
}
